import { removeLocalStorageItem } from '@contexts/Shared/utils';

export function removeUserSession(): void {
  removeLocalStorageItem('token');
  removeLocalStorageItem('user-data');
}
